import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { createVuesticEssential, VaButton } from 'vuestic-ui'
import 'vuestic-ui/styles/essential.css'
import 'vuestic-ui/styles/grid.css'
import 'vuestic-ui/styles/reset.css'
import 'vuestic-ui/styles/typography.css'
import Storage from 'vue-lsp';



createApp(App).use(router).use(createVuesticEssential({ components: { VaButton } ,
    config: {
      colors: {
        variables: {
          primary: "#F26522",
        },
      },
    },
  })).use(Storage, {
    namespace: 'vuejs__', // key prefix
    name: 'ls', // name variable [ls] or [$ls],
    storage: 'local', // storage name session, local, memory
  }
).mount('#app');